module.exports = __webpack_public_path__ + "static/img/detail_bg.f95a079a.png";